import React from 'react';
import styles from '../../assets/stylesheets/common/SectionSeparator.module.css';

const SectionSeparator = ({ 
  variant = 'default',
  spacing = 'default',
  padding = 'none',
  className = ''
}) => {
  const separatorClass = [
    styles.separator,
    styles[`separator--${variant}`],
    styles[`separator--spacing-${spacing}`],
    styles[`separator--padding-${padding}`],
    className
  ].filter(Boolean).join(' ');

  return <div className={separatorClass} />;
};

export default SectionSeparator;
